import { cn } from '@/lib/utils'
import { MONO, eurK } from './format'
import type { MonthCash } from '../types'

const SLATE = '#8A97AD'
const SLATE_DK = '#3A4452'
const H = 104
const BAR_W = 84 // fixed bar width — centred on desktop, scrolls on mobile

/** Net-cash trend — fixed-width slate bars, centred (margins on the ends) when
 *  there's room, horizontally scrollable on narrow screens. */
export function TrendBars({ months }: { months: MonthCash[] }) {
  const max = Math.max(1, ...months.map((m) => m.netCash))
  // Too many months to label every bar on a phone — drop the per-bar € value
  // (bar heights carry the trend) and shorten the month label on mobile only.
  const crowded = months.length > 7
  return (
    <div className="overflow-x-auto">
      {/* Mobile: bars share the full width (no scroll). Desktop: fixed-width, centred. */}
      <div className="flex w-full items-end justify-center gap-1.5 sm:mx-auto sm:w-max sm:gap-6" style={{ minHeight: H + 30 }}>
        {months.map((m, i) => {
          const last = i === months.length - 1
          const barPx = Math.max(4, Math.round((m.netCash / max) * H))
          const short = m.label.replace(/\s*['’]?\d+$/, '') // "Jun 25" -> "Jun"
          return (
            <div
              key={m.key}
              className="flex min-w-0 flex-1 flex-col items-center justify-end gap-1 sm:flex-none"
              style={{ width: BAR_W }}
            >
              <span className={cn('text-[9px]', crowded && 'hidden sm:block', last ? 'font-medium text-stone-700 dark:text-stone-200' : 'text-stone-400', MONO)}>{eurK(m.netCash)}</span>
              <div className="w-full rounded-t" style={{ height: barPx, backgroundColor: last ? SLATE_DK : SLATE }} />
              <span className="text-stone-400 text-[8px] sm:text-[9px]">
                {crowded ? (
                  <>
                    <span className="sm:hidden">{short}</span>
                    <span className="hidden sm:inline">{m.label}</span>
                  </>
                ) : (
                  m.label
                )}
              </span>
            </div>
          )
        })}
      </div>
    </div>
  )
}
